document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".slider");
  const messages = slider.querySelectorAll("span");
  const sliderHeight = 24; // Height of a single message
  let index = 0;

  // Clone the first message and append it to the end for seamless loop
  const firstMessageClone = messages[0].cloneNode(true);
  slider.appendChild(firstMessageClone);

  function slideMessages() {
    index++;
    slider.style.transition = "transform 250ms ease-in-out";
    slider.style.transform = `translateY(-${index * sliderHeight}px)`;

    // Reset when the last (cloned) message is reached
    if (index === messages.length) {
      setTimeout(() => {
        slider.style.transition = "none"; // Remove transition for seamless reset
        slider.style.transform = "translateY(0)";
        index = 0;
      }, 250); // Wait for the animation to complete before resetting
    }
  }

  setInterval(slideMessages, 5000); // Change every 5 seconds
});